module.exports = __webpack_public_path__ + "img/file-pdf.21b7be28.svg";